import { navMenuEventHandler } from './header';
import { handlePostSwipe } from './post';
import { handleListAnimation } from './list';

window.onload = () => {
    navMenuEventHandler();
    handlePostSwipe();
    handleListAnimation();
}
